<template>
  <div class="it-startup-banner-area enhanced-banner">
    <div class="container">
      <div class="row align-items-center m-0">
        <div class="col-lg-6 col-md-12 p-0">
          <div class="it-startup-banner-content">
            <div class="badge-hero mb-3" data-aos="fade-right">
              <i class="ph-rocket-launch"></i>
              <span>Software sob medida para seu negócio</span>
            </div>
            <h1 data-aos="fade-right" data-aos-delay="100">
              Transforme suas ideias em
              <span class="gradient-text">soluções digitais</span>
              de alto impacto
            </h1>
            <p data-aos="fade-right" data-aos-delay="200">
              Somos especialistas em desenvolvimento de software personalizado,
              criando sistemas web, apps mobile e automações que impulsionam
              o crescimento do seu negócio com tecnologia de ponta.
            </p>

            <div class="banner-stats mb-4" data-aos="fade-right" data-aos-delay="300">
              <div class="stat-item">
                <h3>150+</h3>
                <p>Projetos Entregues</p>
              </div>
              <div class="stat-item">
                <h3>98%</h3>
                <p>Satisfação</p>
              </div>
              <div class="stat-item">
                <h3>24/7</h3>
                <p>Suporte</p>
              </div>
            </div>

            <div class="banner-cta" data-aos="fade-right" data-aos-delay="400">
              <a href="https://wa.me/5554992302401?text=Olá! Quero desenvolver uma solução digital com a Fontes Business"
                 target="_blank"
                 class="btn-style-one green-color"
                 rel="noopener noreferrer">
                <i class="flaticon-whatsapp"></i>
                Falar com Especialista
                <i class="ph-caret-right"></i>
              </a>
              <router-link to="/services" class="btn-style-one outline-color">
                Ver Serviços
                <i class="ph-caret-right"></i>
              </router-link>
            </div>

            <div class="trust-badges" data-aos="fade-right" data-aos-delay="500">
              <div class="badge-item">
                <i class="ph-shield-check"></i>
                <span>Código Seguro</span>
              </div>
              <div class="badge-item">
                <i class="ph-lightning"></i>
                <span>Entrega Rápida</span>
              </div>
              <div class="badge-item">
                <i class="ph-headset"></i>
                <span>Suporte Total</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
          <div class="it-startup-banner-image enhanced-image" data-aos="fade-up">
            <!-- Substitua esta URL por uma imagem do Unsplash ou sua própria -->
            <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80"
                 alt="Equipe de Desenvolvimento de Software e IA">

            <div class="floating-card card-1">
              <i class="ph-code"></i>
              <span>Clean Code</span>
            </div>
            <div class="floating-card card-2">
              <i class="ph-rocket"></i>
              <span>Deploy Rápido</span>
            </div>
            <div class="floating-card card-3">
              <i class="ph-brain"></i>
              <span>IA Integrada</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Tech Elements -->
    <div class="tech-background">
      <!-- Grid Pattern -->
      <div class="grid-pattern"></div>

      <!-- Floating Geometric Shapes -->
      <div class="geometric-shape shape-circle"></div>
      <div class="geometric-shape shape-square"></div>
      <div class="geometric-shape shape-triangle"></div>

      <!-- Code Particles -->
      <div class="code-particle particle-1">&lt;/&gt;</div>
      <div class="code-particle particle-2">{ }</div>
      <div class="code-particle particle-3">&lt;AI&gt;</div>
      <div class="code-particle particle-4">npm</div>
      <div class="code-particle particle-5">API</div>
      <div class="code-particle particle-6">()=&gt;</div>

      <!-- Gradient Orbs -->
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainBanner'
}
</script>

<style scoped>
/* ===== BANNER BASE ===== */
.enhanced-banner {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a1a 0%, #16213e 50%, #1a1a2e 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 100px 0;
}

/* ===== TECH BACKGROUND ===== */
.tech-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

/* Grid Pattern - Grade animada */
.grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
      linear-gradient(rgba(109, 93, 252, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(109, 93, 252, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

/* ===== FORMAS GEOMÉTRICAS ===== */
.geometric-shape {
  position: absolute;
  opacity: 0.06;
  animation: floatShape 20s ease-in-out infinite;
}

.shape-circle {
  width: 300px;
  height: 300px;
  border: 3px solid #6D5DFC;
  border-radius: 50%;
  top: 10%;
  right: 5%;
}

.shape-square {
  width: 200px;
  height: 200px;
  border: 3px solid #4361EE;
  transform: rotate(45deg);
  bottom: 20%;
  left: 10%;
  animation-delay: 5s;
}

.shape-triangle {
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 173px solid #8A7DFF;
  top: 60%;
  right: 20%;
  animation-delay: 10s;
}

@keyframes floatShape {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(30px, -30px) rotate(90deg); }
  50% { transform: translate(-20px, 20px) rotate(180deg); }
  75% { transform: translate(20px, 30px) rotate(270deg); }
}

/* ===== PARTÍCULAS DE CÓDIGO ===== */
.code-particle {
  position: absolute;
  color: rgba(109, 93, 252, 0.4);
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 20px;
  animation: floatParticle 15s ease-in-out infinite;
}

.particle-1 {
  top: 15%;
  left: 20%;
  font-size: 24px;
}

.particle-2 {
  top: 70%;
  right: 15%;
  font-size: 28px;
  animation-delay: 3s;
}

.particle-3 {
  top: 40%;
  left: 10%;
  font-size: 18px;
  animation-delay: 6s;
}

.particle-4 {
  bottom: 30%;
  right: 25%;
  font-size: 22px;
  animation-delay: 9s;
}

.particle-5 {
  top: 25%;
  right: 30%;
  font-size: 20px;
  animation-delay: 12s;
}

.particle-6 {
  bottom: 45%;
  left: 25%;
  font-size: 26px;
  animation-delay: 2s;
}

@keyframes floatParticle {
  0%, 100% {
    transform: translateY(0) translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-50px) translateX(30px);
    opacity: 0.7;
  }
}

/* ===== GRADIENT ORBS (Esferas de luz) ===== */
.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  animation: pulseOrb 10s ease-in-out infinite;
}

.orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(109, 93, 252, 0.15) 0%, transparent 70%);
  top: -150px;
  right: -150px;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(67, 97, 238, 0.12) 0%, transparent 70%);
  bottom: -150px;
  left: -150px;
  animation-delay: 5s;
}

@keyframes pulseOrb {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

/* ===== CONTEÚDO ===== */
.it-startup-banner-content {
  position: relative;
  z-index: 2;
}

.it-startup-banner-content h1,
.it-startup-banner-content p {
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.badge-hero {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(109, 93, 252, 0.2);
  border: 1px solid rgba(109, 93, 252, 0.5);
  padding: 8px 16px;
  border-radius: 50px;
  font-weight: 500;
  color: #C5BFFF;
  font-size: 14px;
  backdrop-filter: blur(10px);
}

.badge-hero i {
  font-size: 18px;
  color: #8A7DFF;
}

.gradient-text {
  background: linear-gradient(135deg, #C5BFFF 0%, #9FB0FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ===== ESTATÍSTICAS ===== */
.banner-stats {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.stat-item {
  background: rgba(255, 255, 255, 0.08);
  padding: 15px 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: rgba(109, 93, 252, 0.15);
  border-color: rgba(109, 93, 252, 0.3);
  transform: translateY(-3px);
}

.stat-item h3 {
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  color: #C5BFFF;
  text-shadow: 0 0 20px rgba(109, 93, 252, 0.6);
}

.stat-item p {
  margin: 0;
  font-size: 14px;
  color: #b8b8b8;
}

/* ===== BOTÕES CTA ===== */
.banner-cta {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border-color: #25D366;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  color: white;
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
}

.btn-style-one.outline-color {
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid rgba(109, 93, 252, 0.6);
  color: #C5BFFF;
  backdrop-filter: blur(10px);
}

.btn-style-one.outline-color:hover {
  background: rgba(109, 93, 252, 0.3);
  border-color: #8A7DFF;
  color: white;
}

/* ===== BADGES DE CONFIANÇA (MELHOR CONTRASTE) ===== */
.trust-badges {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.badge-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.12);
  padding: 12px 18px;
  border-radius: 30px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.badge-item:hover {
  background: rgba(109, 93, 252, 0.25);
  border-color: rgba(109, 93, 252, 0.5);
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(109, 93, 252, 0.3);
}

.badge-item span {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.badge-item i {
  font-size: 22px;
  color: #C5BFFF;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

/* ===== IMAGEM ===== */
.enhanced-image {
  position: relative;
  z-index: 2;
}

.enhanced-image img {
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(109, 93, 252, 0.3);
}

.floating-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.98);
  padding: 15px 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  animation: float 3s ease-in-out infinite;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(109, 93, 252, 0.3);
}

.floating-card i {
  font-size: 24px;
  color: #6D5DFC;
}

.floating-card span {
  color: #1a1a2e;
}

.floating-card.card-1 {
  top: 10%;
  right: 10%;
}

.floating-card.card-2 {
  bottom: 30%;
  right: 5%;
  animation-delay: 1s;
}

.floating-card.card-3 {
  top: 50%;
  left: 5%;
  animation-delay: 2s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

/* ===== RESPONSIVO ===== */
@media (max-width: 991px) {
  .enhanced-banner {
    min-height: auto;
    padding: 80px 0;
  }

  .banner-stats,
  .banner-cta,
  .trust-badges {
    justify-content: center;
  }

  .floating-card,
  .code-particle,
  .geometric-shape {
    display: none;
  }
}

@media (max-width: 768px) {
  .stat-item h3 {
    font-size: 24px;
  }

  .badge-item {
    padding: 10px 14px;
  }

  .badge-item span {
    font-size: 13px;
  }
}
</style>